import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Spinner, Alert, Badge } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
//import { apiGet } from '../../api/apiService';
import { apiGet } from '../../services/api/apiMethods';

const CommentsModal = ({ 
  show, 
  onHide, 
  taskId, 
  type = 'officer',
  officerName = 'Officer',
  coordinatorName = 'Coordinator'
}) => {
  const [state, setState] = useState({
    comments: [],
    loading: false,
    error: null
  });

   console.log("CommentsModal Props:", {
    show,
    taskId,
    type,
    officerName, 
    coordinatorName
  });

  const commentColumns = useMemo(() => [
   {
  name: 'Date',
  selector: row => row.commentDate,
  sortable: true,
  center: true, // centers header & cell content
  cell: row => new Date(row.commentDate).toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }),
  width: '250px',
  custom: 'true',
    style: {
   

       textAlign:"center"
    },
},
{
  name: type === 'officer' ? 'Officer' : 'Coordinator',
  selector: row => row.commentBy || row.createdByName,
  center: true,
  width: '250px',
  custom: 'true',
    style: {
 

       textAlign:"center"
    },
},
{
  name: 'Comment',
  selector: row => row.comment || row.actionComment,
  center: true,
  cell: row => (
    <div style={{ whiteSpace: 'pre-line' }}>
      {row.comment || row.actionComment}
    </div>
  ),
    style: {
 

       textAlign:"left"
    },
  grow: 2,
  width: '250px',

},

    // {
    //   name: 'Version',
    //   cell: (row, index) => <Badge bg="secondary">v{state.comments.length - index}</Badge>,
    //   width: '100px',
    //   center: true
    // }
  ], [state.comments, type]);

  const fetchComments = async () => {
     console.log(`Fetching ${type} comments for task ${taskId}`);
    if (!taskId) return;
    
    try {
      setState(prev => ({ ...prev, loading: true, error: null }));
      
      const endpoint = type === 'officer' 
        ? `/TaskTracking/task/${taskId}`
        : `/TaskTracking/ActionComments/${taskId}`;
      
      const response = await apiGet(endpoint);


    console.log("Raw API response:", response);
    console.log("Type:", type);
    console.log("Officer name:", officerName);
    console.log("Coordinator name:", coordinatorName);

      
      if (response) {
 const formattedComments = response.map(item => ({
  ...item,
  commentDate: item.commentDate || item.createdDate,

  commentBy: (item.commentBy && item.commentBy.trim() !== "")
    ? item.commentBy
    : (item.updatedByName && item.updatedByName.trim() !== "")
      ? item.updatedByName
      : (type === 'officer' ? officerName : coordinatorName),

  comment: item.comment || item.actionComment
}))
.sort((a, b) => new Date(b.commentDate) - new Date(a.commentDate));




            console.log("Formatted Comments:", formattedComments);
        
        setState({
          comments: formattedComments,
          loading: false,
          error: null
        });
      } else {
        setState(prev => ({ ...prev, loading: false }));
        toast.error('No comments found');
      }
    } catch (error) {
      console.error('Error fetching comments:', error);
      setState({
        comments: [],
        loading: false,
        error: error.response?.data?.message || 'Failed to load comments'
      });
      toast.error('Failed to load comments');
    }
  };

  useEffect(() => {
    if (show && taskId) {
      fetchComments();
    }
  }, [show, taskId, type]);

  const modalTitle = type === 'officer'
    ? ` Additional Comments ${taskId ? ` (TaskID ${taskId})` : ''}`
    : ` Action Taken Comments${taskId ? ` (TaskID ${taskId})` : ''}`;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton className="modal-customheader" closeVariant="">
        <Modal.Title className="custom-modaltitle">
          <h5 className="mb-0">{modalTitle}</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="custommodal-body">
        {state.loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="btn-primary" />
            <p className="mt-2">Loading comments...</p>
          </div>
        ) : state.error ? (
          <Alert variant="danger">
            <i className="bi bi-exclamation-triangle-fill me-2" />
            {state.error}
          </Alert>
        ) : state.comments.length > 0 ? (
          <DataTable
            columns={commentColumns}
            data={state.comments}
            pagination
       
             customStyles={{
          table: {
            style: {
              borderRadius: "0px",
              overflow: "hidden",
              border: "0px solid #dee2e6",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
            },
          },
          headRow: {
            style: {
              backgroundColor: "#04364A!important",
              minHeight: "48px",
            },
          },
          headCells: {
            style: {
              padding: "10px 14px",
              fontSize: "15px",
              fontWeight: "700",
              color: "white",
              textTransform: "uppercase",
                   backgroundColor: '#04364A',
                    textAlign: "center", 
        justifyContent: "center", 
            },
          },
          rows: {
            style: {
              borderBottom: "1px solid #e2e8f0",
              "&:hover": {
                backgroundColor: "#f9f9f9",
              },
            },
          },
          cells: {
            style: {
              padding: "10px 14px",
              fontSize: "14px",
              color: "#334155",
              textAlign:"centers",
               textAlign: "center", 
        justifyContent: "center", 
            },
          },
        }}
          />
        ) : (
          <div className="text-center py-4">
            <i className="bi bi-chat-left fs-1 text-muted" />
            <p className="mt-2">No comments available</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CommentsModal;